import { useToolPreferences } from 'hooks/usePreferences';
import { WithApolloContext } from 'modules/Apollo/types';
import { isWindows } from 'utils/browserDetect';

export const useIsScrollInverted = ({ context }: WithApolloContext): boolean => {
  const [prefs] = useToolPreferences({ context });
  const invertScroll = !!prefs?.invertScroll;
  return invertScroll;
};

export const useGetScrollScale = ({
  scale,
  context,
}: { scale: number } & WithApolloContext): number => {
  const invertScroll = useIsScrollInverted({ context });
  const windowsScale = isWindows() ? -scale : scale;
  return invertScroll ? windowsScale * -1 : windowsScale;
};

export const useIsWwwcInverted = ({ context }: WithApolloContext): boolean => {
  const [prefs] = useToolPreferences({ context });
  return Boolean(prefs?.wwwc.invertDragDirection);
};
